module.exports = __webpack_public_path__ + "assets/img/2d27-co.svg";